import Confirmation from './confirmation';

export default Confirmation;
